import { useState } from "react";

import { questions } from "../Data";

function useAnswers() {
  const [answers, setAnswers] = useState({});

  const onAnswerChange = (question, answer) => {
    setAnswers((prevState) => {
      if (answer) {
        return { ...prevState, [question]: answer };
      } else {
        delete prevState[question];
        return { ...prevState };
      }
    });
  };

  const resetAnswers = (category, topic) => {
    setAnswers((prevState) => {
      Object.keys(questions(category, topic)).forEach((i) => {
        delete prevState[i];
      });
      return { ...prevState };
    });
  };

  const getAnswer = (question) => {
    return answers[question];
  };

  return { answers, onAnswerChange, resetAnswers, getAnswer };
}

export default useAnswers;
